<template>
    <section class="app-main">

        <div class="top-bar">
            <el-input placeholder="搜索" v-model="search" @change="getData()"  style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <el-card>
            <el-table :data="tableData" v-loading="table_load" height="630" style="width: 100%">
                <el-table-column  prop="apply_type"    label="申请类型"   align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.apply_type == 1">企业合伙人</div>
                        <div v-else>个人合伙人</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="corporate_name"    label="企业名称"   align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.apply_type == 1">{{scope.row.corporate_name}}</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="batch"    label="姓名"   align="center">
                    <template slot-scope="scope">
                        <div type="info">{{scope.row.name}} {{scope.row.surname}}</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="email"    label="邮箱"    align="center" > </el-table-column>
                <el-table-column  prop="phone"    label="电话"     align="center"></el-table-column>
                <el-table-column  prop="created_at" label="申请时间"   width="180"  align="center" ></el-table-column>
                <el-table-column   label="编辑"     align="center"  width="180">
                    <template slot-scope="scope">
                        <div class="table-btns">
                           <el-button type="success" plain size="small" @click="reason_modal2 = true;row2 = scope.row">同意</el-button><br/>
                           <el-button type="danger " plain size="small" @click="reason_modal = true;row = scope.row">拒绝</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" style="padding:10px" :total="total" :page-size="20"  @current-change="loadPage"></el-pagination>
        </el-card>
        <el-dialog width="600px" title="确定通过吗？" :visible.sync="reason_modal2" center append-to-body >
            <!-- <el-row style="text-align:center;">
                <el-date-picker
                style="width:322px;"
                v-model="value1"
                :picker-options="expireTimeOption"
                type="date"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-row> -->
            <el-row type="flex" justify="center" style="margin-top:20px;">
                <el-button type="info " style="margin-right: 30px; width: 120px" @click="reason_modal2 = false" >取消</el-button >
                <el-button type="success" style="margin-left: 30px; width: 120px" @click="handleProcess(row2, 2)" :disabled="disabled" >确定</el-button >
            </el-row>
        </el-dialog>
        <el-dialog
        width="600px"
        title="拒绝原因"
        :visible.sync="reason_modal"
        center
        append-to-body
        >
        <el-row
            class="row-height m-bottom-4"
            type="flex"
            justify="center"
            style="line-height: 40px"
        >
            拒绝原因：
            <el-input
            placeholder="输入拒绝原因"
            v-model="reason"
            style="width: 300px"
            ></el-input>
        </el-row>
        <el-row type="flex" justify="center" style="margin-top:20px;">
            <el-button
            type="info "
            style="margin-right: 30px; width: 120px"
            @click="reason_modal = false"
            >取消</el-button
            >
            <el-button
            type="success"
            style="margin-left: 30px; width: 120px"
            @click="handleProcess(row,3)"
            :disabled="disabled"
            >提交</el-button
            >
        </el-row>
        </el-dialog>
    </section>
</template>

<script>
import { partner, partner_audit } from '@/api/merchant.js'
export default {
    data() {
        return {
            search: '',
            page:1,
            total:0,
            tableData:[],
            reason_modal: false,
            reason:'',
            row:'',
            reason_modal2: false,
            row2: '',
            value1: "",
            expireTimeOption: {
                disabledDate(date) {
					return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				}
            }
        }
    },
    methods: {
        getData(){
            let params = { 
                page: this.page,
                audit_status: 1
            }
            if(this.search != '') {
                params.keywords = this.search
            }
            partner( params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 审核
        handleProcess(row, status){
            let params = {
                audit_status: status,
            }
            if (this.reason != '' && status == 3) {
                params.refusal_reasons = this.reason
            }
            if (status == 2) {
                params.status = 1
                // if (this.value1 != "" && this.value1 != null) {
                //     params.valid_time = this.value1
                // }else{
                //     this.$message({message:"请先选择日期时间",type:"error",offset:'200'})
                //     return false
                // }
            }
            partner_audit(row.id ,params).then(res => {
                if (res.code == 20000) {
                    this.reason = ''
                    this.reason_modal = false
                    this.reason_modal2 = false
                    this.$message({message:res.msg,type:"success",offset:'200'})
                    this.getData();
                }else{
                    this.$message({message:res.msg,type:"error",offset:'200'})
                }
            }).catch(err => {
                this.reason_modal = false
                this.reason_modal2 = false
                console.log(err)
            })
             
            
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.shop-title {
    text-align: left;
    height: 40px;
    line-height: 40px;
}
.img-title {
    text-align: left;
    height: 70px;
    line-height: 70px;
}
.shop-info {
    border: 1px solid #e0e0e0;
    text-align: left;
    padding-left: 10px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
}
.imgs-box {
    text-align: left;
}



</style>

